import _map from 'lodash/map'

import Image from 'components/Image'
import Title from 'components/Title'

import Styled from './styled'

export default function SectionOurCustomer({ data }) {
  const title = data?.title
  const logos = _map(data?.logos, item => item?.url)

  return (
    <Styled>
      <div className="title-block">
        <Title level={2}>{title}</Title>
      </div>

      <div className="logo-container">
        {_map(logos, (logo, index) => {
          return (
            <div className="image" key={index}>
              <Image src={logo} imgixWidth={100} width={100} height={75} alt="" />
            </div>
          )
        })}
      </div>
    </Styled>
  )
}
